import { AppSidebar } from "@humanex/ui/components";
import { cn } from "@humanex/ui/libs";
import { Link, useMatchRoute } from "@tanstack/react-router";
import {
  // BarChart2,
  BookOpen, // DollarSign,
  FileText,
  LayoutDashboard,
  LogOut,
  Settings,
  Users
} from "lucide-react";

import { Logo } from "@/components";
import { useAuthStore } from "@/stores/auth.store";

const NAV_ITEMS = [
  { to: "/home", label: "Dashboard", icon: LayoutDashboard },
  { to: "/accounts", label: "Tài khoản", icon: Users },
  { to: "/programs", label: "Chương trình", icon: BookOpen },
  // { to: "/commissions", label: "Hoa hồng", icon: DollarSign },
  { to: "/documents", label: "Tài liệu", icon: FileText },
  // { to: "/reports/revenue", label: "Báo cáo", icon: BarChart2 },
  { to: "/config", label: "Cấu hình", icon: Settings }
] as const;

export function Sidebar({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const match = useMatchRoute();
  const signOut = useAuthStore((state) => state.signOut);

  return (
    <AppSidebar
      open={isOpen}
      onClose={onClose}
      collapseBelow="md"
      className="w-56 md:w-14 lg:w-56 border border-white bg-white/95 md:bg-white/80 rounded-r-3xl md:rounded-3xl shadow-sm"
    >
      <div className="py-4 border-b border-primary-100 flex flex-col justify-center gap-2 items-center">
        <Logo className="h-16 w-40 md:h-10 md:w-10 lg:h-16 lg:w-40" />
        <span className="md:hidden lg:block text-responsive-lg font-medium text-primary">ADMIN PORTAL</span>
      </div>
      <nav className="flex-1 py-4 space-y-0.5 px-2">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => {
          const isActive = match({ to });
          return (
            <Link
              key={to}
              to={to as string}
              onClick={onClose}
              className={cn(
                "flex items-center gap-2 px-3 py-2 rounded text-responsive-md transition-colors",
                "md:justify-center lg:justify-start",
                isActive ? "bg-primary-100/80 text-primary font-medium" : "text-slate-400 hover:bg-primary-50"
              )}
            >
              <Icon className="w-4 h-4 flex-shrink-0" />
              <span className="md:hidden lg:inline">{label}</span>
            </Link>
          );
        })}
      </nav>
      <div className="px-3 py-4 border-t border-primary-100">
        <button
          onClick={() => signOut()}
          className={cn(
            "flex items-center gap-2 px-3 py-2 w-full rounded text-responsive-md transition-colors",
            "md:justify-center lg:justify-start",
            "hover:bg-error-100 font-medium",
            "text-error-500/80 hover:text-error-500"
          )}
        >
          <LogOut className="w-4 h-4 flex-shrink-0" />
          <span className="md:hidden lg:inline">Đăng xuất</span>
        </button>
      </div>
    </AppSidebar>
  );
}
